define('handlebars/helpers',[
    'Handlebars',
    'underscore',
    'moment/moment',
    'bizzabo/utils',
    'bizzabo/consts',
    'timezoneJS',
    'bizzabo/config'
], function(
    Handlebars,
    _,
    GlobalMoment,
    UTILS,
    Consts,
    timezoneJS,
    CONFIG
    ) {

    Handlebars.registerHelper("each_day_string", function(eventModel, options) {
        var buffer = "";
        if (eventModel) {
            var startDate = eventModel.get("start-date");
            var endDate = eventModel.get("end-date");
            var timeZone = eventModel.get('time-zone-id');

            var localStartDate = eventModel.get("local-start-date");
            var localEndDate = eventModel.get("local-end-date");
            var numberOfDays = UTILS.getDiffInDays(localStartDate, localEndDate);

            for (var dayIndex = 0; dayIndex < numberOfDays; dayIndex++) {
                var dateObject = new timezoneJS.Date(UTILS.getDaysFrom(startDate, dayIndex, timeZone));
                dateObject.setTimezone(timeZone);
                dateObject.setTime(UTILS.getDaysFrom(startDate, dayIndex, timeZone));
                var item = {
                    index : dayIndex,
                    dayString : dateObject.toString("EEEEEEEEEEEE, MMMM dd, yyyy", timeZone)
                };
                buffer += options.fn(item);
            }
        }
        return buffer;
    });

    Handlebars.registerHelper('timeFormatFrom24Hour', function(time24) {
        if (_.isUndefined(time24)) {
            return '';
        }
        var parts = time24.split(':');
        if (parts.length != 2) {
            return '';
        }
        var AMorPM = 'AM';
        if (parts[0] >= 12) {
            AMorPM = 'PM';
        }
        parts[0] = (parts[0] % 12);
        if (parts[0] === 0) {
            parts[0] = '12';
        }

        var padding_zero = function(x, n) {
            return String('000000' + x).slice(-1 * n)
        };

        var result = parts[0] + ':' + padding_zero(parts[1], 2) + '<small>' + AMorPM + '</small>';
        return new Handlebars.SafeString(result);
    });

    Handlebars.registerHelper('unescapedHTML', function(html) {
        if (_.isUndefined(html)) {
            return '';
        }
        return new Handlebars.SafeString(html);
    });

    Handlebars.registerHelper('addOne', function(context, options) {
        return options.fn(context + 1);
    });

    Handlebars.registerHelper('config', function(context, options) {
        return options.fn(CONFIG);
    });

    Handlebars.registerHelper('consts', function(context, options) {
        return options.fn(Consts);
    });

    Handlebars.registerHelper('eq', function(val, val2, options) {
        if (val == val2) {
            return options.fn(this);
        }
    });

    Handlebars.registerHelper('neq', function(val, val2, options) {
        if (val != val2) {
            return options.fn(this);
        }
    });

    Handlebars.registerHelper('eventDates', function(eventModel) {
        var startDate = eventModel["start-date"];
        var endDate = eventModel["end-date"];
        var timeZone = eventModel['time-zone-id'];
//		var numberOfDays = UTILS.getDiffInDays(startDate, endDate);

        var startDateObject = new timezoneJS.Date(startDate);
        var startMonthString = startDateObject.toString("MMMM", timeZone);
        var startDayString = startDateObject.toString("dd", timeZone);
        var startYearString = startDateObject.toString("yyyy", timeZone);

        var endDateObject = new timezoneJS.Date(endDate);
        var endMonthString = endDateObject.toString("MMMM", timeZone);
        var endDayString = endDateObject.toString("dd", timeZone);
        var endYearString = endDateObject.toString("yyyy", timeZone);

        var result = "";
        if (endYearString == startYearString) {
            if (endMonthString == startMonthString) {
                if (startDayString == endDayString) {
                    result = startMonthString + " " + startDayString + ", " + startYearString;
                } else {
                    result = startMonthString + " " + startDayString + " - " + endDayString + ", " + startYearString;
                }
            } else {
                result = startMonthString + " " + startDayString + " - " + endMonthString + " " + endDayString + ", " + startYearString;
            }
        } else {
            result = startMonthString + " " + startDayString + " " + startYearString + " - " + endMonthString + " " + endDayString + " " + endYearString;
        }

        return new Handlebars.SafeString(result);
    });

    Handlebars.registerHelper('timeago', function(eventModel) {
        var startDate = eventModel["start-date"];
        var endDate = eventModel["end-date"];
        var now = new Date().getTime();

        if (now > endDate) {
            var result = moment(endDate).fromNow();
        } else if (now < startDate) {
            result = moment(startDate).fromNow();
        } else {
            result = "ongoing";
        }

        return new Handlebars.SafeString(result);
    });

    Handlebars.registerHelper('countryByCode', function(countryCode) {
        var result = Consts.Countries[countryCode];
        return new Handlebars.SafeString(result);
    });

    Handlebars.registerHelper('countryOptions', function() {
        var result = "";
        for (var countryCode in Consts.Countries) {
            var countryName = Consts.Countries[countryCode];
            result += '<option value="' + countryCode + '">' + countryName + '</option>';
        }
        return new Handlebars.SafeString(result);
    });

    Handlebars.registerHelper('newline', function(number) {
        number = number || 1;
        var result = [];
        for (var i = 0; i < number; i++) {
            result.push('\n');
        };
        return new Handlebars.SafeString(result.join(''));
    });

    Handlebars.registerHelper("commas", function(number) {
        return UTILS.numberWithCommas(number);
    });

    Handlebars.registerHelper("communityAttendingStatus", function(attendingStatus) {
        switch (attendingStatus) {
            case 'rsvp':
                return 'Joined';
            case 'checkedin' :
                return 'Checked-In';
            case 'populated' :
                return 'Auto Populated';
        }
    });
    Handlebars.registerHelper("communityEmailStatus", function(emailStatus) {
        switch (emailStatus) {
            case 'invited' :
                return 'Invite Sent';
            case 'inprogress':
                return 'In Progress';
            case 'bounced':
                return 'Bounced';
            case 'notinvited':
                return 'Not Invited Yet';
        }
    });


    Handlebars.registerHelper("formatDate", function(timestampInMs, format) {
        if(timestampInMs && format){
            var date = moment.unix(timestampInMs/1000);
            return date.format(format);
        }
    });

    Handlebars.registerHelper('moduloPlusOne', function(num, mod) {
        num = (num !== undefined ) ? num : 0;
        return num % mod + 1;
    });

    Handlebars.registerHelper('timeStampTimeZone', function(timeZone, timeStamp) {
        if (!timeStamp) {
            return '';
        }
        var date = new timezoneJS.Date(timeStamp);
        date.setTimezone(timeZone);
        date.setTime(timeStamp);
        var parsedDate = (date.getMonth() + 1) +'/' + date.getDate() + '/' + date.getFullYear();

        return parsedDate;
    });

    Handlebars.registerHelper('timeStampTimeZoneToTime', function(timeZone, timeStamp) {
        if (!timeStamp) {
            return '';
        }

        var date = new timezoneJS.Date(timeStamp);
        date.setTimezone(timeZone);
        date.setTime(timeStamp);
        var parsedHour = date.getHours();
        var parsedMinutes = date.getMinutes() + ''; //convert to string
        parsedMinutes = parsedMinutes.length == 1 ? '0' + parsedMinutes : parsedMinutes;
        var parsedTime = UTILS.ensureAmPmFormat(parsedHour + ':' + parsedMinutes);

        return parsedTime;
    });

    return Handlebars;

});
